import React from "react";
import Rollbar from '../utils/RollbarTracking'
import Select from 'react-select';
import axios from 'axios'
import { toast } from 'react-toastify';

export class SelectCatalogues extends React.Component {

  constructor(props)  {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
      catalogues: [],
      selectedCatalogue: {}
  }

  componentWillMount() {
    this.fetchCatalogues()
    if (this.props.filter) {
        this.setState({selectedCatalogue: this.props.filter})
    }
  }

  handleChange(evt) {
    this.setState({selectedCatalogue: evt})
    if (evt.catalogueID) {
      this.props.updateParameters({filter: evt})
    } else {
      this.props.updateParameters({filter: null})
    }
  }

  fetchCatalogues = async () => {
    axios.get('/catalogues')
        .then(data => {
            let temp = data
            temp.unshift({catalogueName: 'None', catalogueID: null})
            this.setState({
                catalogues: data
            });
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to fetch catalogues')
        })
  }

  render() {
    return (
        <Select
            name="catalogues"
            options={this.state.catalogues}
            value={this.state.selectedCatalogue}
            onChange={this.handleChange}
            getOptionLabel={(option)=>option.catalogueName}
            getOptionValue={(option)=>option.catalogueID}
        />
    );
  }
}